import styled from "styled-components";

import { TicketsHeaderStyledProps as Props } from "./TicketsHeader.types";
import CONSTANTS from "config/constants";

const { tablet } = CONSTANTS.BREAKPOINTS;

export const stepStyles = {
  flex: 0.2,
  height: 4,
  borderRadius: 2,
  marginRight: 4
};

export const stepResponsiveStyles = {
  flex: 1
};

const TicketsHeaderStyled = styled.div<Props>`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 1.6rem;
  display: flex;
  background-color: var(--palette-dark-blue-s13-l11);
  border-bottom: 0.2rem solid var(--palette-mid-blue-s13-l18);
  min-width: max-content;

  @media (max-width: ${tablet - 1}px) {
    padding-top: 2.8rem;
    padding-bottom: 1.2rem;
  }

  .TicketsHeader {
    &__go-back {
      .GoBack {
        padding: 0.6rem 0.8rem;

        &__icon {
          @media (max-width: ${tablet - 1}px) {
            padding: 0;
          }

          & svg {
            width: 3.6rem;
            height: 3.6rem;
            padding-top: 1rem;
            padding-left: 0.48rem;
          }
        }

        &__title {
          font-size: 1.6rem;
          color: var(--palette-white);
          font-weight: 600;
        }
      }

      @media (max-width: ${tablet - 1}px) {
        align-self: start;
      }
    }

    &__status {
      justify-content: center;
      display: flex;
      flex: 1;

      @media (max-width: ${tablet - 1}px) {
        position: absolute;
        top: 0;
        left: 0;
        padding: 1.6rem 2.4rem;
        min-width: 100%;
      }
    }

    &__step {
      background-color: var(--palette-white);
      ${stepStyles};

      @media (max-width: ${tablet - 1}px) {
        ${stepResponsiveStyles};
      }
    }

    &__stepEmpty {
      background-color: var(--palette-mid-blue-s15-l20);
      ${stepStyles};

      @media (max-width: ${tablet - 1}px) {
        ${stepResponsiveStyles};
      }
    }

    &__timer {
      display: flex;
      padding-right: 3.2rem;

      &__title {
        margin-right: 0.8rem;
        color: var(--palette-white);

        @media (max-width: ${tablet - 1}px) {
          font-size: 1.2rem;
          line-height: 2.4rem;
        }
      }

      @media (max-width: ${tablet - 1}px) {
        align-self: start;
        padding-left: 6.4rem;
        margin-top: -3.2rem;
      }
    }

    &__close {
      cursor: pointer;
      padding: 1rem 1.2rem;
      background-color: var(--palette-gray-s0-l30-a40);
      border-radius: 1.2rem;
    }
  }
`;

export default TicketsHeaderStyled;
